var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('h1',[_vm._v("HT for Web")]),_c('h2',[_vm._v("构建先进 2D 和 3D 可视化所需要的一切")]),_c('ht-view',{ref:"htView",staticClass:"ht-view",attrs:{"auto-invalidate":true,"type":"2d"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }